import { combineReducers } from 'redux';
import auction from 'bus/otpusk/auction/reducer';

export default combineReducers(
  {
    auction,
  }
);
